import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader, provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { identityInterceptor, provideChatbot } from '@rrsolutionsit/atl-chatbot-lib';

import { routes } from './app.routes';
import { authInterceptor } from './core/auth/auth.interceptor';
import { provideMarkdown } from 'ngx-markdown';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, identityInterceptor])),
    provideTranslateService({
      fallbackLang: 'en',
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader,
      },
    }),
    provideTranslateHttpLoader({ prefix: './i18n/', suffix: '.json' }),
    provideAnimationsAsync('noop'),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideMarkdown(),
    provideChatbot({
      apiUrl: environment.URL_AI,
      surface: 'embedded',
      primaryColor: 'var(--color-primary)',
      fontSize: 'var(--font-size-base)',
      allowedHostOrigins: [window.location.origin],
      allowInsecureTransport: environment.local,
      domains: {
        web: {
          agent: 'web_agent',
          identity: 'anonymous',
          allowsSessionManagement: false,
          showsAgentPicker: false,
        },
        crm: {
          agent: 'crm_agent',
          identity: 'bearer',
          allowsSessionManagement: true,
          showsAgentPicker: true,
        },
        admin: {
          agent: 'admin_agent',
          identity: 'bearer',
          allowsSessionManagement: true,
          showsAgentPicker: false,
          login: { url: environment.domainLoginUrls.admin },
        },
        camo: {
          agent: 'camo_agent',
          identity: 'bearer',
          allowsSessionManagement: true,
          showsAgentPicker: false,
          login: { url: environment.domainLoginUrls.camo },
        },
        pilot: {
          agent: 'pilot_agent',
          identity: 'bearer',
          allowsSessionManagement: true,
          showsAgentPicker: false,
          login: { url: environment.domainLoginUrls.pilot, tokenField: 'access_token' },
        },
        maintenance: {
          agent: 'maintenance_agent',
          identity: 'bearer',
          allowsSessionManagement: true,
          showsAgentPicker: false,
          login: { url: environment.domainLoginUrls.maintenance },
        },
      },
    }),
  ],
};
